import React, { useState } from "react";
import RequestService from "../../services/request.service";


import { Button, Modal, Table } from 'react-bootstrap'


import Pagination from "../../services/Pagination";


import { toast } from 'react-toastify'

import AuthService from "../../features/auth/auth.service";


import ModalReporteAsesor from './ModalReporteAsesor'


// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
// } from 'chart.js';
// import { Line } from 'react-chartjs-2';
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend
// );

const GerenciaAsesores = () =>{


  const [allSessionsCount,setCounter] = useState(0);
  const sessionsPerPage = 10
  const [currentPage, setCurrentPage] = useState(1);

  const [ pagina, setPagina ] = useState(0)
  const [ text_busqueda, setTextoBusqueda ] = useState('')


  const [ cargando_, setCargando ] = useState( true )

	const skull = {
	  years: [],
	  meses: [],
	  tramites_atender: []
	}

  const [ reporte, setReporte ] = useState<any>({...skull})

  
      const currentUser  = AuthService.getCurrentUser();

  const cargarMiReporte = async(page:number)=>{
    try{
      setCargando(true)
      let skip = 0
      if(page===0) skip = 0; else skip = (page*10);
      let response : any = await RequestService.getEndPoint('gerente/busqueda_asesores/'+currentUser.uuid+'?where='+text_busqueda+'&skip='+skip)
      // console.log(response.data)
      setPagina(page)
      // setTotalResulados(response.data.totalCount)
      setCounter(response.data.totalCount)
      // setPaginas(response.data.numberPages)

      setReporte(response.data)
      setCargando(false)
      // toast.success('La lista de Tramites del día '+fecha+' fue cargada')
    }
    catch(e){
      setCargando(false)
      toast.error('Problemas al intentar generar tu reporte. Contacta con los administradores del sistema')
    }
  }


  const busquedaEtiquetas = async () =>{
    setPagina(0)
    cargarMiReporte(0)
    setCurrentPage(1)
  }

  React.useEffect(() => {
    cargarMiReporte(0)
  }, []);





  const [ asesor_detalle, setAsesorDetalle ] = useState<any>({})



  const [showDetallesAsesor, setShowDetalleAsesor] = useState(false);

  const handleCloseModalAsesor = () => setShowDetalleAsesor(false);

  const detallesAsesor = async (asesor:any) => {
  	setShowDetalleAsesor(true);
  	setAsesorDetalle(asesor)
  }





	return (

		<React.Fragment>
			<div className="container">
				

				<h5>Busqueda de Asesores</h5>

                              <div className="">
                                <label className="form-label">Búsqueda</label>
                                <div className="input-group mb-3">
                                  <input type="text" className="form-control" onKeyDown={(e)=>{if(e.keyCode === 13){ busquedaEtiquetas() }}} placeholder="" value={text_busqueda} onChange={event => setTextoBusqueda(event.target.value)} />
                                  <button onClick={busquedaEtiquetas} className="btn btn-default" type="button" id="button-addon2"><i className="fa fa-search" /></button>
                                </div>
                              </div>




                          {  (!cargando_) && (

                              <>



                                      



                                     {
                                       reporte.results.length > 0 && (

                                         <>


                                         <h6>Listado de Asesores</h6>


                                          <Table responsive="lg">
                                            <thead>
                                              <tr>
                                                <th scope="col">Nombre(s)</th>
                                                <th scope="col">Apellidos</th>
                                                <th scope="col">Email</th>
                                                <th scope="col">Celular</th>
                                                <th scope="col"></th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {
                                                reporte.results.map( (asesor:any) =>
                                                    <tr key={ Math.random().toString(36).substr(2, 9) } style={{fontSize:12}}>
                                                      <td className="v text-left">
                                                      	<p className="nm"><b>{asesor.nombres} </b></p>
                                                      </td>
                                                      <td className="v text-left" style={{"width":"300px"}}>
                                                      	{asesor.paterno} {asesor.materno}
                                                      </td>
                                                      <td className="v text-right" style={{"width":"100px"}}>
                                                      	{asesor.email}
                                                      </td>
                                                      <td className="v text-right" style={{"width":"100px"}}>
                                                      	{asesor.celular}
                                                      </td>
                                                      <td className="v text-right" style={{"width":"200px"}}>
                                                      		<Button onClick={()=>{detallesAsesor(asesor)}} size="sm"><i className="fa fa-list"/></Button>
                                                      </td>
                                                    </tr>
                                                 )
                                              }

                                            </tbody>
                                          </Table>


                  									        <Pagination
                  									          itemsCount={allSessionsCount}
                  									          itemsPerPage={sessionsPerPage}
                  									          currentPage={currentPage}
                  									          setCurrentPage={setCurrentPage}
                  									          cambiarPaginaEvento={cargarMiReporte}
                  									          alwaysShown={false}
                  									        />




                                          </>



                                         )
                                     }






                              </>

                           )}

                          {  cargando_ && (

                              <>
                                <div className="loader">
                                  <div className="loaderBar"></div>
                                </div>
                              </>


                           )}





			</div>





      {
        showDetallesAsesor && (
          <ModalReporteAsesor showDetallesAsesor={showDetallesAsesor} handleCloseModalAsesor={handleCloseModalAsesor} asesor_detalle={asesor_detalle} />
        )
      }



		</React.Fragment>


	)
	

}


export default GerenciaAsesores